import { Spin, Typography } from 'antd';
import './WaitingScreen.scss';

function WaitingScreen() {
  return (
    <div className="waiting-screen">
      <Spin size="large" />
      <Typography.Title level={4}>
        Preparing your simulation...
      </Typography.Title>
      <Typography.Paragraph type="secondary">
        We're setting up a unique scenario for you. This usually takes a few
        seconds.
      </Typography.Paragraph>
    </div>
  );
}

export default WaitingScreen;
